import useAudio, { AudioState } from './useAudio'
export { AudioState }
export default useAudio
